
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm6 8c1.105 0 2 1.343 2 3s-.895 3-2 3-2-1.343-2-3 .895-3 2-3zM10 8c1.105 0 2 1.343 2 3s-.895 3-2 3-2-1.343-2-3 .895-3 2-3zm6 20c-5.215 0-9.544-4.371-10-9.947 2.93 1.691 6.377 2.658 10 2.658s7.07-.963 10-2.654c-.455 5.576-4.785 9.942-10 9.942z"}})])
          )
        }
      }
    